import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _ClassNames from 'classnames';
import { styles } from './styles';
import ListOption from './ListOption';
import { getHelpMeValues } from './utils';

function MobileScroll(props) {
  const {
    classes,
    topicsOption,
    selectedTopic,
    changeFilter,
    mediaTypes,
    selectedMediaType,
    go,
    selectedRelatedTopic,
    clientData,
    isNotHomePage,
  } = props;
  const helpMeValues = getHelpMeValues(clientData);
  return (
    <Grid
      item
      xs={12}
      className={_ClassNames(
        classes.root,
        isNotHomePage ? classes.sectionPageRoot : undefined,
      )}
    >
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12} sm={5}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item xs={5}>
              <Typography align="right" className={classes.label}>
                {helpMeValues[0]}
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <ListOption
                data={topicsOption}
                value={selectedTopic}
                changeHandler={changeFilter}
                type="selectedTopic"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={5}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item xs={5}>
              <Typography align="right" className={classes.label}>
                {helpMeValues[1]}
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <ListOption
                data={mediaTypes}
                value={selectedMediaType}
                changeHandler={changeFilter}
                type="selectedMediaType"
                placeholder="select media type"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            onClick={go}
            disabled={
              !selectedTopic || !selectedRelatedTopic || !selectedMediaType
            }
          >
            GO
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

MobileScroll.propTypes = {
  classes: PropTypes.object,
  topicsOption: PropTypes.object,
  selectedTopic: PropTypes.string,
  changeFilter: PropTypes.func,
  mediaTypes: PropTypes.array,
  selectedMediaType: PropTypes.string,
  go: PropTypes.func,
  selectedRelatedTopic: PropTypes.string,
  clientData: PropTypes.object,
  isNotHomePage: PropTypes.bool,
};

export default withStyles(styles)(MobileScroll);
